import { render, staticRenderFns } from "./addxyf.vue?vue&type=template&id=6fd261fe&scoped=true"
import script from "./addxyf.vue?vue&type=script&lang=js"
export * from "./addxyf.vue?vue&type=script&lang=js"
import style0 from "./addxyf.vue?vue&type=style&index=0&id=6fd261fe&prod&lang=less&scoped=true"
import style1 from "./addxyf.vue?vue&type=style&index=1&id=6fd261fe&prod&lang=less"
import style2 from "./addxyf.vue?vue&type=style&index=2&id=6fd261fe&prod&lang=less"
import style3 from "./addxyf.vue?vue&type=style&index=3&id=6fd261fe&prod&lang=less&scoped=true"
import style4 from "./addxyf.vue?vue&type=style&index=4&id=6fd261fe&prod&lang=less&scoped=true"
import style5 from "./addxyf.vue?vue&type=style&index=5&id=6fd261fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd261fe",
  null
  
)

export default component.exports